import React from 'react';

// Import images
import foxBizIcon from '~/common/images/fox-biz-icon.png';
import wsjIcon from '~/common/images/wsj-icon.png';
import techCrunchIcon from '~/common/images/tech-crunch-icon.png';
import cnnIcon from '~/common/images/cnn-icon.svg';
import forbesIcon from '~/common/images/forbes-icon.png';
import incIcon from '~/common/images/inc-icon.png';

import styles from './featured-in.css';

export default () => (
    <section className={styles.wrapper}>
        <h3 className={styles.header}>Grasshopper has been featured in:</h3>
        <div className={styles.images}>
            <img
                alt="Wall Street Journal"
                src={wsjIcon}
                title="Wall Street Journal"
            />
            <img
                alt="Fox Business"
                src={foxBizIcon}
                title="Fox Business"
            />
            <img
                alt="Forbes"
                src={forbesIcon}
                title="Forbes"
            />
            <img
                alt="Inc500"
                src={incIcon}
                title="Inc500"
            />
            <img
                alt="CNN"
                src={cnnIcon}
                title="CNN"
            />
            <img
                alt="TechCrunch"
                src={techCrunchIcon}
                title="TechCrunch"
            />
        </div>
    </section>
);
